import type { MedalScoreThresholds } from "@dailywars/core/db";
import type { MedalTier } from "@dailywars/core/medals";

import { MedalIcon } from "#/components/MedalIcon";

const MEDAL_ORDER: readonly MedalTier[] = ["gold", "silver", "bronze"];

export function MedalThresholdScores({ thresholds }: { thresholds: MedalScoreThresholds }) {
  return (
    <div className="flex items-center justify-center gap-4">
      {MEDAL_ORDER.map((tier) => (
        <MedalScoreCell key={tier} tier={tier} score={thresholds[tier]} />
      ))}
    </div>
  );
}

function MedalScoreCell({ tier, score }: { tier: MedalTier; score: number | null }) {
  return (
    <div className="flex items-center gap-1.5">
      <MedalIcon tier={tier} size={16} />
      <span className="text-sm font-semibold tabular-nums text-foreground">
        {score === null ? "—" : `${score}`}
      </span>
    </div>
  );
}
